import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";

export default function ReopenDialog({ open, busy, onClose, onConfirm }) {
  const [reason, setReason] = useState("");
  const trimmed = reason.trim();

  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      onClose={busy ? undefined : onClose}
    >
      <DialogTitle sx={{ fontWeight: 700 }}>Reopen this script?</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
          Marks can be changed again. The script must be submitted again
          afterwards.
        </Typography>
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={3}
          label="Reason"
          value={reason}
          onChange={(event) => setReason(event.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button disabled={busy} onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={busy || !trimmed}
          onClick={() => onConfirm(trimmed)}
        >
          {busy ? "Reopening…" : "Reopen"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
